export const enum AuthenticateAction {
  ApiRequest = 'ApiRequest',
  Ready = 'Ready',
  Authenticate = 'Authenticate',
  Success = 'Success',
  Error = 'Error'
}
